import { CameraSource } from 'lib_ts/enums/machine-msg.enum';
import { ALLOCATED_STREAM_METADATA_BYTES } from 'lib_ts/enums/machine.enums';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { StreamingRoutes } from 'lib_ts/enums/routing/routes/streaming';
import { ICameraStreamResponseMsg } from 'lib_ts/interfaces/machine-msg/i-camera-stream';
import { BaseRESTService } from 'services/_base-rest.service';

export class StreamingService extends BaseRESTService {
  private static instance: StreamingService;
  static getInstance(): StreamingService {
    if (!StreamingService.instance) {
      StreamingService.instance = new StreamingService();
    }

    return StreamingService.instance;
  }

  private constructor() {
    super({
      controller: Controller.Streaming,
    });
  }

  async getLastFrame(payload: {
    machineID: string;
    source: CameraSource;
  }): Promise<Partial<ICameraStreamResponseMsg> | undefined> {
    return await this.post(
      {
        uri: StreamingRoutes.LastFrame,
        responseType: 'arraybuffer',
      },
      payload
    )
      .then(async (arrayBuffer: ArrayBuffer | undefined) => {
        if (!arrayBuffer) {
          return undefined;
        }

        /*
          Server converts the stream metadata into binary, prepends the length of the metadata and appends the image buffer

          Buffer format:
          [4-byte metadata length][metadata JSON][binary image data]

          Below we turn the ArrayBuffer back into an object we can use in the client
        */
        const dataView = new DataView(arrayBuffer);
        const metaLength = dataView.getUint32(0);

        const metaBytes = new Uint8Array(
          arrayBuffer,
          ALLOCATED_STREAM_METADATA_BYTES,
          metaLength
        );
        const metaJson = new TextDecoder().decode(metaBytes);
        const metadata = JSON.parse(metaJson);

        const bufferOffset = ALLOCATED_STREAM_METADATA_BYTES + metaLength;
        const buffer = new Uint8Array(arrayBuffer, bufferOffset);

        const res: ICameraStreamResponseMsg = {
          ...metadata,
          received_timestamp: Date.now(),
          buffer,
        };
        return res;
      })
      .catch((e) => {
        console.error(e);
        return undefined;
      });
  }
}
